import React from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import * as actions from '../../actions';

import { FormattedMessage, injectIntl } from 'react-intl';

import { Redirect, withRouter } from 'react-router-dom';

class BestRatedList extends React.Component {
    constructor(props) {
        super();
    }
    clickedProvider = provider => {
        this.props.clickedProvider(provider);
    };
    render() {
        const { data } = this.props;
        if (data.providerList && data.providerList.length == 0) {
            return <p style={{ padding: 10 }}>No Provider Found</p>;
        }

        return (
            <ul>
                {data.providerList &&
                    data.providerList.length > 0 &&
                    data.providerList.map((provider, index) => {
                        return (
                            <li
                                style={{ cursor: 'pointer' }}
                                key={index}
                                onClick={() => this.clickedProvider(provider)}
                            >
                                <a>
                                    <div className="list-left-near lln1">
                                        <img
                                            src={provider.proImage.small}
                                            alt="list"
                                        />
                                    </div>
                                    <div className="list-left-near lln2">
                                        <h5>{provider.businessName}</h5>
                                        <span>{provider.tagline}</span>
                                    </div>
                                    <div className="list-left-near lln3">
                                        <span>
                                            {provider.rating.slice(0, -1)}
                                        </span>
                                    </div>
                                </a>
                            </li>
                        );
                    })}
            </ul>
        );
    }
}

const composedComponent = compose(connect(null, actions));
export default composedComponent(withRouter(injectIntl(BestRatedList)));



// WEBPACK FOOTER //
// ./src/components/Providers/BestRatedList.jsx